import { GrowthBookProvider as RootGrowthBookProvider } from '@growthbook/growthbook-react';
import PropTypes from 'prop-types';

import { useEffect } from 'react';
import { getCookie } from '../../../analytics/helpers/getCookie/getCookie';

const GrowthBookProvider = ({ client, children }) => {
  const featureCookie = getCookie('ri_features');

  useEffect(() => {
    // If the feature cookie exists, set it as the feature payload
    if (featureCookie) {
      console.log('Feature cookie found');

      const payload = client.getPayload();

      console.log('Existing payload:', JSON.stringify(payload, null, 2));

      client.setPayload({
        ...payload,
        features: {
          ...payload.features,
          ...JSON.parse(featureCookie),
        },
      });

      const newPayload = client.getPayload();
      console.log('New payload:', JSON.stringify(newPayload, null, 2));
    }
  }, [client, featureCookie]);

  return (
    <RootGrowthBookProvider growthbook={client}>
      {children}
    </RootGrowthBookProvider>
  );
};

GrowthBookProvider.propTypes = {
  children: PropTypes.node,
  client: PropTypes.object.isRequired,
};

GrowthBookProvider.defaultProps = {
  children: null,
};

export { GrowthBookProvider };
